import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useApi, eventImage, money } from "@/lib/api";
import { Page, Spinner, Empty } from "@/components/common";
import { fmtDate } from "@/components/EventCard";

export default function MyEvents() {
  const { data, isLoading } = useApi("/events/mine");
  const events = data?.events || [];
  return (
    <Page className="max-w-5xl">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="font-mono text-xs uppercase tracking-widest text-stone-500">Host</p>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight">My events</h1>
        </div>
        <Link to="/events/new" data-testid="my-events-new-btn" className="inline-flex items-center gap-1.5 bg-[#FF5C00] hover:bg-[#E04E00] text-white text-sm font-semibold px-5 py-3 rounded-full transition-colors"><Plus className="h-4 w-4" /> New</Link>
      </div>
      <div className="mt-10 space-y-3">
        {isLoading ? <Spinner /> : events.length === 0 ? <Empty title="You haven't hosted anything yet" testId="my-events-empty" /> : events.map((e) => (
          <Link key={e.id} to={`/manage/${e.id}`} data-testid={`my-event-${e.id}`} className="flex items-center gap-4 p-3 pr-5 rounded-3xl bg-white border border-stone-200 hover:border-stone-900 transition-colors">
            <img src={eventImage(e)} alt="" className="h-16 w-16 rounded-2xl object-cover" />
            <div className="flex-1 min-w-0">
              <p className="font-display text-lg font-bold truncate">{e.title}</p>
              <p className="font-mono text-xs text-stone-500">{fmtDate(e.start_time)}</p>
            </div>
            <span className="hidden sm:block font-mono text-xs">{money(e.price)}</span>
            <span className="font-mono text-xs">{e.attendee_count || 0} going</span>
            {e.cancelled ? <span className="font-mono text-[10px] bg-red-600 text-white px-2 py-0.5 rounded-full">Cancelled</span> : <span className="font-mono text-[10px] bg-stone-100 px-2 py-0.5 rounded-full capitalize">{e.status}</span>}
          </Link>
        ))}
      </div>
    </Page>
  );
}
